<template>
  <div id="topo">

    <z-centralized-toolbar>
      <v-btn text color="primary" :to="{ name: 'NotasFiscaisLista' }" exact>
        <v-icon left>mdi-arrow-left</v-icon>
        Voltar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text @click="$router.push({ name: 'NotasFiscaisLista' })" :disabled="emitindo || salvando">Cancelar</v-btn>
      <v-btn class="ml-3" color="primary" @click="salvarNFSE" :loading="emitindo || salvando" :disabled="!form_valido">Salvar</v-btn>

      <v-divider vertical class="mx-3"></v-divider>

      <v-btn color="primary" @click="emitirNFSE" :loading="emitindo" :disabled="!form_valido">Emitir</v-btn>
    </z-centralized-toolbar>

    <v-divider></v-divider>

    <z-loading :loading="loadingList" height="100vh" color="indigo"></z-loading>

    <v-form v-model="form_valido" ref="form" lazy-validation>

      <z-container v-show="!loadingList">

        <z-status-nfse
          :situacao="nfse.rps_situacao"
          class="mb-3"
        >Aguardando</z-status-nfse>


        <v-card class="mb-5">
          <v-tabs v-model="tabAtiva">
            <v-tab>
              Emitente
            </v-tab>
            <v-tab>
              Tomador
            </v-tab>
            <v-tab>
              Competência e Local
            </v-tab>
            <v-tab>
              Serviço
            </v-tab>
            <v-tab>
              Valores
            </v-tab>
            <v-tab>
              Impostos Federais
            </v-tab>
            <v-tab>
              Valor Total
            </v-tab>
            <v-tabs-slider color="primary"></v-tabs-slider>
          </v-tabs>

          <v-divider></v-divider>

          <v-tabs-items v-model="tabAtiva">
            <!-- Tab 0: Emitente -->
            <v-tab-item eager>
              <v-card flat>
                <v-card-text>
                  <v-row dense>
                    <v-col sm="9">
                      <z-text-field
                        v-model="nfse.emitente_razao_social"
                        label="Emitente Razão Social"
                        readonly
                      ></z-text-field>
                    </v-col>
                    <v-col sm="3">
                      <z-text-field
                        label="CPF/CNPJ"
                        readonly
                        hide-details
                        :value="nfse.emitente_cnpj"
                      ></z-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

            </v-tab-item>

            <!-- Tab 1: Tomador -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="3">
                      <!-- <v-text-field label="CPF/CNPJ" v-model="nfse.tomador.cpfcnpj" :readonly="!isNotaAvulsa" :rules="[regras.obrigatorio]" return-masked-value></v-text-field> -->
                      <z-cpf-cnpj
                        label="CPF/CNPJ"
                        v-model="nfse.tomador.cpfcnpj"
                        append-icon="mdi-magnify"
                        :rules="[regras.obrigatorio]"
                        @keyup="buscarTomador"
                        @click:append="$refs.DialogoBuscarClientes.abrir()"
                      ></z-cpf-cnpj>
                    </v-col>

                    <v-col sm="9">
                      <z-text-field
                        v-model="nfse.tomador.razao_social"
                        label="Razão Social"
                        :rules="[regras.obrigatorio]"
                      >
                        <template #append v-if="nfse.tomador.id">
                          <v-btn
                            small
                            text
                            :to="{ name: 'ClientesEditar', params: { id: nfse.tomador.id } }"
                            target="_blank"
                          >Editar</v-btn>
                        </template>
                      </z-text-field>
                    </v-col>

                    <v-col sm="4">
                      <z-text-field readonly label="CEP" v-model="nfse.tomador.cep" :rules="[regras.obrigatorio]"></z-text-field>
                    </v-col>

                    <v-col sm="4">
                      <z-select
                        v-model="nfse.tomador.uf"
                        :items="estados"
                        label="Estado"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-select>
                    </v-col>

                    <v-col sm="4">
                      <z-autocomplete
                        v-model="nfse.tomador.codigo_municipio"
                        :items="getCidadesByUF(nfse.tomador.uf)"
                        label="Cidade"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-autocomplete>
                    </v-col>

                    <v-col sm="9">
                      <z-text-field
                        label="Endereço"
                        v-model="nfse.tomador.endereco"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-text-field>
                    </v-col>

                    <v-col sm="3">
                      <z-text-field
                        label="Número"
                        v-model="nfse.tomador.numero"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-text-field>
                    </v-col>

                    <v-col sm="6">
                      <z-text-field
                        label="Bairro"
                        v-model="nfse.tomador.bairro"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-text-field>
                    </v-col>

                    <v-col sm="6">
                      <z-text-field
                        label="Complemento"
                        v-model="nfse.tomador.complemento"
                        readonly
                      ></z-text-field>
                    </v-col>

                    <v-col sm="9">
                      <z-text-field
                        label="Email"
                        v-model="nfse.tomador.email"
                        readonly
                      ></z-text-field>
                    </v-col>

                    <v-col sm="3">
                      <z-text-field
                        label="Telefone"
                        v-model="nfse.tomador.telefone"
                        readonly
                        mask="(##) ####-####"
                        return-masked-value
                      ></z-text-field>
                    </v-col>

                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 2: Competência e Local -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="2">
                      <z-date-picker-menu
                        v-model="nfse.rps_data_emissao"
                        label="Data Emissão"
                        readonly
                      ></z-date-picker-menu>
                    </v-col>

                    <v-col sm="4">
                      <z-select
                        v-model="nfse.natureza_operacao"
                        :items="natureza_operacao"
                        label="Local"
                      ></z-select>
                    </v-col>

                    <v-col sm="2">
                      <z-select
                        v-model="nfse.servico.estado"
                        :items="estados"
                        label="Estado"
                        readonly
                      ></z-select>
                    </v-col>

                    <v-col sm="4">
                      <z-select
                        v-model="nfse.servico.codigo_municipio"
                        :items="getCidadesByUF(nfse.servico.estado)"
                        label="Cidade"
                        readonly
                      ></z-select>
                    </v-col>

                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 3: Serviço -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-text>
                  <v-row dense>

                    <v-col>

                      <v-autocomplete
                        v-model="nfse.servico.codigo_servico"
                        v-bind="$v.TEXT_FIELDS"
                        :rules="[regras.obrigatorio]"
                        :items="lista_codigos_atividades"
                        item-text="codigo_servico"
                        item-value="codigo_servico"
                        label="Código Serviço"
                        @change="updateServico"
                      >
                        <template v-slot:item="{ item, attrs, on }">
                          <v-list-item dense v-bind="attrs" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.descricao_completa }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                 (Alíquota: {{ item.aliquota }}%)
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>

                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.aliquota"
                        label="Valor Alíquota"
                        suffix="%"
                        decimais="0"
                        :rules="[regras.obrigatorio]"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-select
                        v-model="nfse.servico.valores.iss_retido"
                        :items="[{value: 1, text: 'Sim'}, {value: 2, text: 'Não'}]"
                        label="Iss retido"
                        @change="calcularValores"
                      ></z-select>
                    </v-col>


                    <v-col sm="12">
                      <z-textarea
                        label="Discriminação"
                        v-model="nfse.servico.discriminacao"
                        :rules="[regras.obrigatorio]"
                      ></z-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 4: Valores -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-title class="subtitle-2">
                  Valores
                </v-card-title>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="3">
                      <z-campo-valor
                      label="Valor Serviço"
                      v-model="nfse.servico.valores.valor_servicos"
                      decimais="2"
                      :rules="[regras.maiorquezero]"
                      readonly
                      @change="calcularValores"></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="Valor Deduções"
                        v-model="nfse.servico.valores.valor_deducoes"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="Desconto Incondicionado"
                        v-model="nfse.servico.valores.desconto_incondicionado"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="Desconto Condicionado"
                        v-model="nfse.servico.valores.desconto_condicionado"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="Valor Outras Retenções"
                        v-model="nfse.servico.valores.outras_retencoes"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 5: Impostos Federais -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-title class="subtitle-2">
                  Impostos Federais
                </v-card-title>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="3">
                      <z-campo-valor
                        label="Pis"
                        v-model="nfse.servico.valores.valor_pis"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="Cofins"
                        v-model="nfse.servico.valores.valor_cofins"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="IR"
                        v-model="nfse.servico.valores.valor_ir"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="INSS"
                        v-model="nfse.servico.valores.valor_inss"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="CSLL"
                        v-model="nfse.servico.valores.valor_csll"
                        decimais="2"
                        @change="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <!-- <v-col sm="3">
                      <z-campo-valor
                        label="Valor ISS Retido"
                        v-model="nfse.servico.valores.iss_retido"
                        decimais="2"
                        readonly
                      ></z-campo-valor>
                    </v-col> -->
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 6: Valor Total -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-title class="subtitle-2">
                  Valor Total
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col sm="3">
                      <z-campo-valor label="Base de Cálculo" v-model="nfse.servico.valores.base_calculo" decimais="2" readonly></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor label="Valor líquido da nota" v-model="nfse.servico.valores.valor_liquido_nfse" decimais="2" readonly></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor label="Valor do ISS a pagar" v-model="nfse.servico.valores.valor_iss" decimais="2" readonly></z-campo-valor>
                    </v-col>

                    <!-- <v-col sm="3">
                      <z-campo-valor label="Valor ISS Retido" v-model="nfse.servico.valores.valor_iss_retido" decimais="2" readonly></z-campo-valor>
                    </v-col> -->

                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>

        <v-card class="mb-5">
          <v-card-title class="subtitle-2">
            Valor Total
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col sm="3">
                <z-campo-valor label="Base de Cálculo" v-model="nfse.servico.valores.base_calculo" decimais="2" readonly></z-campo-valor>
              </v-col>

              <v-col sm="3">
                <z-campo-valor label="Valor líquido da nota" v-model="nfse.servico.valores.valor_liquido_nfse" decimais="2" readonly></z-campo-valor>
              </v-col>

              <v-col sm="3">
                <z-campo-valor label="Valor do ISS a pagar" v-model="nfse.servico.valores.valor_iss" decimais="2" readonly></z-campo-valor>
              </v-col>

              <!-- <v-col sm="3">
                <z-campo-valor label="Valor ISS Retido" v-model="nfse.servico.valores.valor_iss_retido" decimais="2" readonly></z-campo-valor>
              </v-col> -->

            </v-row>
          </v-card-text>
        </v-card>

        <z-dev v-if="false">
          <v-card tile class="mb-5">
            <v-card-title class="subtitle-2">
              Valores
            </v-card-title>
            <v-card-text>
              <v-row dense>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_servicos"
                    label="Valor Serviço"
                    decimais="2"
                    :rules="[regras.maiorquezero]"
                    :readonly="!isNotaAvulsa"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_deducoes"
                    label="Valor Deduções"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.desconto_incondicionado"
                    label="Desconto Incondicionado"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.desconto_condicionado"
                    label="Desconto Condicionado"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.outras_retencoes"
                    label="Valor Outras Retenções"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
          <v-card tile class="mb-5">
            <v-card-title class="subtitle-2">
              Impostos Federais
            </v-card-title>
            <v-card-text>
              <v-row dense>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_pis"
                    label="Pis"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_cofins"
                    label="Cofins"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_ir"
                    label="IR"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    label="INSS"
                    v-model="nfse.servico.valores.valor_inss"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    label="CSLL"
                    v-model="nfse.servico.valores.valor_csll"
                    decimais="2"
                    @change="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <!-- <v-col sm="3">
                  <z-campo-valor label="Valor ISS Retido" v-model="nfse.servico.valores.iss_retido" decimais="2" readonly></z-campo-valor>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
        </z-dev>

        <v-container fluid class="pt-0">

          <v-row dense>
            <v-col sm="12">

              <v-alert color="error" :icon="$icon.ALERTA" v-if="nfse.retorno_codigo || nfse.retorno_mensagem || nfse.retorno_correcao" dense outlined>
                <div v-if="nfse.retorno_codigo"><b>Código Erro: </b> {{ nfse.retorno_codigo }}</div>
                <div v-if="nfse.retorno_mensagem"><b>Mensagem: </b> {{ nfse.retorno_correcao }}</div>
                <div v-if="nfse.erro"><b>Erro: </b> {{ nfse.erro }}</div>
                <div v-if="nfse.retorno_correcao"><b>Correção: </b> {{ nfse.retorno_mensagem }}</div>
              </v-alert>

            </v-col>
          </v-row>

        </v-container>


        <!-- <v-subheader>Intermediário Serviço</v-subheader>
        <v-divider></v-divider>

        <v-container fluid grid-list-md>
          <v-row>

            <v-col sm="4">
              <v-text-field label="Razão Social" v-model="nfse.intermediario_servico.razao_social" readonly></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field label="CNPJ" v-model="nfse.intermediario_servico.cnpj" readonly></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field label="Inscrição Municipal" v-model="nfse.intermediario_servico.inscricao_municipal" readonly></v-text-field>
            </v-col>


          </v-row>
        </v-container>

        <v-subheader>Construção Civil</v-subheader>
        <v-divider></v-divider>

        <v-container fluid grid-list-md>
          <v-row>

            <v-col sm="4">
              <v-text-field label="Código de Obra" v-model="nfse.construcao_civil.razao_social" readonly></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field label="Art" v-model="nfse.construcao_civil.art" readonly></v-text-field>
            </v-col>

          </v-row>
        </v-container> -->


      </z-container>

    </v-form>

    <ProcessoEmissaoDialog ref="dialogoProcessoEmissao" :nota="nfse"></ProcessoEmissaoDialog>
    <dialogo-buscar-clientes ref="DialogoBuscarClientes" @busca:selecionar="setTomador"></dialogo-buscar-clientes>
  </div>
</template>

<script>
  import '@/components/buscas';
  // import {mapState, mapActions} from 'vuex'
  import { natureza_operacao, regime_especial_tributacao } from "./aux/codigos.js";
  import aliquotas from "./aux/aliquotas.js";
  import globals from '@/app/globals.js';
  import dayjs from 'dayjs'
  import { dataBR, valorBR, onlyNumbers, valorUS } from '@/app/helpers/formatacoes.js'
  import notaFiscaisApi from '@/app/services/notasfiscais.js'
  import emitentesApi from "@/app/services/emitentes.js"

  import ProcessoEmissaoDialog from "./ProcessoEmissaoDialog.vue"

  export default {
    name: 'NotasFiscaisForm',

    components: {
      ProcessoEmissaoDialog,
    },

    data() {
      return {
        emitente: {},
        loadingList: false,
        form_valido: true,
        globals,
        aliquotas,
        cidades_nfse: [],
        codigo_servico: {
          codigo_servico: '1.03/631190001',
          descricao: '',
          aliquota: 2,
        },
        natureza_operacao: natureza_operacao,
        regime_especial_tributacao: regime_especial_tributacao,
        emitente: {
          id: null,
          cnpj: null
        },

        nfse: {
          emitente_id: null,
          emitente_cnpj: null,
          rps_situacao: 1,
          retorno_codigo: null,
          retorno_correcao: null,
          retorno_mensagem: null,

          numero: 1234,
          serie: 1,
          tipo:1,

          rps_data_emissao: dayjs().format("YYYY-MM-DD"),
          natureza_operacao: 1,
          // 1 – Tributação no município
          // 2 - Tributação fora do município
          // 3 - Isenção
          // 4 - Imune
          // 5 – Exigibilidade suspensa por decisão judicial
          // 6 – Exigibilidade suspensa por procedimento administrativo

          regime_especial_tributacao: 5,
          // 1 – Microempresa municipal
          // 2 - Estimativa
          // 3 – Sociedade de profissionais
          // 4 – Cooperativa
          // 5 – MEI – Simples Nacional
          // 6 – ME EPP – Simples Nacional

          optante_simples_nacional: 1,
          incentivador_cultural: 2,
          status: 1,

          tomador: {
            cpfcnpj: '',
            razao_social: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            codigo_municipio: '',
            uf: '',
            cep: '',
            email: '',
            telefone: '',
            id: null,
          },

          servico: {

            codigo_servico: "1.03/631190001",
            item_lista_servico: "1.03",
            codigo_tributacao_municipio: "631190001",
            discriminacao: "",
            codigo_municipio: "2604106",
            estado: 'PE',

            valores: {
              valor_servicos: 0.00,
              desconto_incondicionado: 0.00,
              desconto_condicionado: 0.00,
              valor_deducoes: 0.00,
              valor_pis: 0.00,
              valor_cofins: 0.00,
              valor_inss: 0.00,
              valor_ir: 0.00,
              valor_csll: 0.00,
              iss_retido: 2,
              valor_iss: 0.00,
              valor_iss_retido: 0.00,
              outras_retencoes: 0.00,
              base_calculo: 0.00,
              aliquota: 5,
              valor_liquido_nfse: 0.00
            }
          },

          intermediario_servico: {
            razao_social: 'INSCRICAO DE TESTE SIATU - D AGUA -PAULINO S',
            cnpj: '99999999000191',
            inscricao_municipal: '8041700010'
          },

          construcao_civil: {
            codigo_obra: '1234',
            art: '1234'
          }

        },

        emitindo: false,
        regras: {
          obrigatorio: v => !!v || 'Campo obrigatório',
          cnpj: v => !!v.cnpj || 'CPF/CNPJ obrigatório',
          maiorquezero: v => valorUS(v) > 0 || 'O valor é orbigatório'
        },
        from_route: {
          name: ''
        },

        salvando: false,
        tabAtiva: null,
      }
    },

    computed: {
      ordemservico() {
        return this.$store.state.ordemservico.ordemservico;
      },

      lista_codigos_atividades() {
        return aliquotas.map(item => {
          return {
            codigo_servico: `${item.codigo_servico}/${item.codigo_atividade}`,
            descricao: item.descricao_servico,
            aliquota: item.aliquota,
            descricao_completa: `${item.codigo_servico}/${item.codigo_atividade} - ${item.descricao_servico}`
          };
        })
      },

      estados() {
        return this.$store.state.listas.estados.map(estado => {
          return estado.sigla
        });
      },

      emitentes() {
        return this.$store.state.listas.clientes.map(emitente => {
          return {
            'text': emitente.nome,
            'value': emitente.id,
            ...emitente
          }
        })
      },

      isAdicionando() {
        return this.$route.name == 'NotasFiscaisAdicionar';
      },

      isEditando() {
        return this.$route.name == 'NotasFiscaisEditar';
      },

      isNotaAvulsa() {
        return this.$route.name == 'NotaServicoAvulsa';
      }
    },

    // watch: {
    //   nfse: {
    //     handler() {
    //       this.calcularValores();
    //     },
    //     deep: true
    //   }
    // },

    async mounted () {
      this.loadingList = true;
      await this.$store.dispatch('listas/clientes');
      await this.carregarEstados();
      await this.carregarEmitente();

      console.log('ROUTE NAME:', this.$route.params.id);

      if (this.$route.params.id && this.$route.name == 'NotasFiscaisEditar') {
        await this.$store.dispatch('notasfiscais/abrirNotaFiscal', this.$route.params.id);
        this.nfse = { ...this.$store.state.notasfiscais.notafiscal };
      }

      // setTimeout(() => {
      //   // this.$refs.form.resetValidation();
        this.loadingList = false;
      //   // this.$vuetify.goTo("#topo");
        this.init();
      // }, 0);
    },

    methods: {
      async init() {
        // this.setHTMLOverflowYVisible(false);
        // this.$refs.dialogo.abrir();

        if (this.$route.name == 'NotasFiscaisAdicionar' && this.$route.query.ordemservico_id) {
          await this.$store.dispatch('ordemservico/abrir', this.$route.query.ordemservico_id);
          this.preencherNotaFiscal(this.ordemservico);
          //   this.setDiscriminacaoNFSE(this.ordemservico);
          //   this.calcularValores();
        }
        this.setEmitente(this.emitente);
      },

      async carregarEmitente(emitente) {
        try {
          const response = await emitentesApi.first();
          this.emitente = response.data;
        } catch (error) {
          if (error.response && error.response.status === 404) {
            this.limparForm();
          }
        }
      },

      async emitirNFSE() {
        if (!this.$refs.form.validate()) {
          return false;
        }

        await this.salvarNFSE();
        this.$refs.dialogoProcessoEmissao.abrir();
      },

      async salvarNFSE() {
        if (!this.$refs.form.validate()) {
          return false;
        }

        try {
          this.salvando = true;
          if (this.nfse.id) {
            await notaFiscaisApi.update(this.nfse);
          } else {
            await notaFiscaisApi.store(this.nfse);
          }

          // this.$router.push({ name: 'NotasFiscaisLista' })

        } catch (error) {
          throw error;
        } finally {
          this.salvando = false;
        }
      },

      preencherNotaFiscal(ordemservico) {
        // this.codigo_servico = [ordemservico.servico.item_lista_servico, ordemservico.servico.codigo_tributacao_municipio].join('/");

        // this.nfse.tipo_nota                           = ordemservico.tipo_nota;
        this.nfse.servico_id                          = ordemservico.id;
        this.nfse.servico.item_lista_servico          = "1.03";
        this.nfse.servico.codigo_tributacao_municipio = "631190001";
        this.nfse.servico.discriminacao               = "Prestação de serviço de valor adicionado SVA.";
        this.nfse.servico.codigo_municipio            = this.emitente.codigo_municipio;
        // this.nfse.servico.estado                      = "PE"; //ordemservico.servico.estado;
        // this.nfse.rps_situacao                        = 1;
        // this.nfse.retorno_codigo                      = ordemservico.retorno_codigo;
        // this.nfse.retorno_correcao                    = ordemservico.retorno_correcao;
        // this.nfse.retorno_mensagem                    = ordemservico.retorno_mensagem;

        this.nfse.tomador = {
          id: ordemservico.cliente.id,
          cpfcnpj: ordemservico.cliente.cpf_cnpj,
          razao_social: ordemservico.cliente.nome,
          endereco: ordemservico.cliente.endereco,
          numero: ordemservico.cliente.numero,
          complemento: ordemservico.cliente.ponto_referencia,
          bairro: ordemservico.cliente.bairro,
          codigo_municipio: ordemservico.cliente.codigo_municipio,
          uf: ordemservico.cliente.estado,
          cep: ordemservico.cliente.cep,
          email: ordemservico.cliente.email,
          telefone: ordemservico.cliente.telefone,
          is_mei: ordemservico.cliente.is_mei // precisa adicionar esse campo no Cliente
        }

        // this.nfse.servico.valores.id                      = ordemservico.servico.id;
        this.nfse.servico.valores.valor_servicos          = ordemservico.total_servicos;
        // this.nfse.servico.valores.desconto_incondicionado = 0;
        // this.nfse.servico.valores.desconto_condicionado   = 0;
        // this.nfse.servico.valores.valor_deducoes          = 0;
        // this.nfse.servico.valores.iss_retido              = ordemservico.servico.iss_retido == null ? ordemservico.cliente.retem_iss == 1 ? 1 : 2 : ordemservico.servico.iss_retido ;
        // this.nfse.servico.valores.valor_iss               = ordemservico.servico.valor_iss;
        // this.nfse.servico.valores.valor_iss_retido        = ordemservico.servico.valor_iss_retido;
        // this.nfse.servico.valores.outras_retencoes        = ordemservico.servico.outras_retencoes;
        // this.nfse.servico.valores.base_calculo            = ordemservico.servico.base_calculo;
        // this.nfse.servico.valores.aliquota                = ordemservico.servico.aliquota;
        // this.nfse.servico.valores.valor_liquido_nfse      = ordemservico.servico.valor_liquido_nfse;

        // Impostos federais - somente se o emitente não for do simples nacional
        // if (!this.emitente.simples_nacional) {
        //   this.nfse.servico.valores.valor_pis    = ordemservico.servico.valor_pis;
        //   this.nfse.servico.valores.valor_cofins = ordemservico.servico.valor_cofins;
        //   this.nfse.servico.valores.valor_inss   = ordemservico.servico.valor_inss || 0;
        //   this.nfse.servico.valores.valor_ir     = ordemservico.servico.valor_ir;
        //   this.nfse.servico.valores.valor_csll   = ordemservico.servico.valor_csll;
        // }

        this.calcularValores();
        this.setDiscriminacaoNFSE(ordemservico);
      },

      setHTMLOverflowYVisible(state = true) {
        let html = document.querySelector("html");
        html.style.overflowY = state == false ? "hidden" : "";
      },

      getCidadesByUF(sigla) {
        if (sigla) {
          const estado = this.$store.state.listas.estados.find(estado => estado.sigla == sigla);

          if (estado) {
            return estado.cidades.map(cidade => {
              return {
                'text': cidade.nome.toUpperCase(),
                'value': cidade.codigo
              }
            })
          }
        }

        return [];
      },


      setDiscriminacaoNFSE(ordemservico) {

        this.nfse.servico.discriminacao = `Prestação de serviço de valor adicionado SVA.
Prestação de serviço de oficina mecânica referente à Ordem de Serviço Nº ${ordemservico.id}.
Valor aproximado dos tributos R$ ${valorBR((ordemservico.total_servicos * this.emitente.ibpt)/100)} Fonte: (IBPT)`;

      },

      onChangeEmitente(emitente) {
        this.nfse.emitente_id = emitente.value;
        this.nfse.emitente_cnpj = emitente.cnpj;
        // this.setDiscriminacaoNFSE(this.fatura);
      },

      setEmitente(emitente) {
        this.nfse.emitente_id = emitente.id;
        this.nfse.emitente_cnpj = emitente.cnpj;
        this.nfse.emitente_razao_social = emitente.razao;
      },

      calcularValores() {
        console.log('calcularValores');

        const valores = this.nfse.servico.valores;

        valores.base_calculo = valores.valor_servicos;
        valores.valor_liquido_nfse = valores.valor_servicos;

        valores.base_calculo = valores.base_calculo - valores.valor_deducoes;
        valores.base_calculo = valores.base_calculo - valores.desconto_incondicionado;

        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.desconto_incondicionado;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.desconto_condicionado;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.outras_retencoes;

        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_pis;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_cofins;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_inss;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_ir;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_csll;

        valores.valor_iss = valores.base_calculo * (valores.aliquota/100);
        if (this.nfse.servico.valores.iss_retido == 1) {
            valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_iss;
            valores.valor_iss_retido = valores.valor_iss;
        } else {
          valores.valor_iss_retido = null;
        }


        if (this.nfse.tomador.is_mei == 1) {
          console.log('Tomador é MEI, ISS = 0');
          // valores.valor_iss = 0.00;
          valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_iss;
          valores.valor_iss_retido = 0.00;
          this.nfse.servico.valores.iss_retido = 2;
        }
      },

      voltar() {
        if (this.$route.name == 'NovaNotaServico') {
          this.$router.push({name: 'FaturamentoLista'});
        } else {
          this.$router.push({name: 'NotasFiscaisLista'});
        }
      },

      async buscarTomador(event) {
        // if (this.isEditando || this.isAdicionando) {
        //   return false;
        // }

        // const cpfcnpj = onlyNumbers(event.target.value);
        const cpfcnpj = (event.target.value);
        if (cpfcnpj.length == 14 || cpfcnpj.length == 18) {
          await this.$store.dispatch('notasfiscais/getTomador', cpfcnpj);
          const tomador = this.$store.state.notasfiscais.tomador;

          this.setTomador(tomador);
        }
      },

      setTomador(tomador) {

        console.log("setTomador", tomador);

        this.nfse.tomador = {
          id: tomador.id,
          cpfcnpj: tomador.cpf_cnpj,
          razao_social: tomador.nome,
          endereco: tomador.endereco,
          numero: tomador.numero,
          complemento: tomador.ponto_referencia,
          bairro: tomador.bairro,
          codigo_municipio: tomador.codigo_municipio,
          uf: tomador.estado,
          cep: tomador.cep,
          email: tomador.email,
          telefone: tomador.telefone,
        }
      },

      async carregarEstados() {
        console.log("Carregar estados");
        this.$store.dispatch('listas/estados');

        // const dia = 1;
        // const estados = await this.$storage.remember('estados', dia * 1, () => {
        //   console.log("Rodou callback cache");
        //   this.$store.dispatch('listas/estados');
        //   return this.$store.state.listas.estados;
        // });
      },

      updateServico() {
        const [item_lista_servico, codigo_tributacao_municipio] = this.nfse.servico.codigo_servico.split('/');
        this.nfse.servico.item_lista_servico = item_lista_servico;
        this.nfse.servico.codigo_tributacao_municipio = codigo_tributacao_municipio;
      }

    },


  }
</script>

<style scoped>

</style>
